import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: `"Arial"`,
    allVariants: {
      fontFamily: "'Arial'",
      textTransform: "none",
    },
    button: {
      textTransform: "none",
      fontFamily: "'Arial'",
    },
  },
  palette: {
    primary: {
      main: "#1C39BB",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
